import Tabs from '@/components/ui/tabs';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { months } from '../../utils/months-list';

export const CalendarTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const prefixUrl = '/calendar';

  const tabs = useMemo(() => {
    return [
      {
        name: 'Whole year',
        current: location.pathname.includes(`whole-year`),
        onClick: () => navigate(`${prefixUrl}/whole-year`),
      },
      ...months.map((month) => ({
        name: month,
        current: location.pathname.includes(month.toLowerCase()),
        onClick: () => navigate(`${prefixUrl}/${month.toLowerCase()}`),
      })),
    ];
  }, [location.pathname, navigate]);

  return (
    <Tabs
      tabs={tabs}
      selectClassNames="!mt-0"
      tabsClassesNames="!flex flex-wrap !gap-4 font-bold !font-cadiz -mb-8"
      textClassNames="!text-sh-xxxs"
    />
  );
};
